const features = [
  {
    icon: 'ri-shield-check-line',
    title: '高清流畅不缓冲',
    desc: '全线采用高速CDN加速与智能码率适配技术，确保在任何网络环境下都能获得高清流畅不缓冲的观影体验，拒绝卡顿等待。',
  },
  {
    icon: 'ri-star-smile-line',
    title: '独家内容每日更新',
    desc: '深度合作蜜桃视频与红桃视频等品牌频道，每日精选上新独家专题内容，香蕉视频樱花视频VIP资源免费开放，保持内容新鲜度。',
  },
  {
    icon: 'ri-thumb-up-line',
    title: '智能排行榜精选',
    desc: '基于多维热度算法与用户偏好分析，实时生成热播排行榜，帮你快速发现全网最受关注的好视频，精准匹配个人兴趣。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-100 font-heading mb-3">
            平台特色
          </h2>
          <p className="text-sm text-foreground-500 max-w-[560px] mx-auto">
            日皮视频致力于为用户打造极致的在线观影体验，三大核心优势让精彩触手可及
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((item) => (
            <div
              key={item.title}
              className="group relative p-6 md:p-8 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-500/30 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-500 mb-5 group-hover:scale-110 transition-transform duration-300">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-100 mb-2 font-heading">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}